'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));
var _inherits = _interopDefault(require('@babel/runtime/helpers/inherits'));
var _possibleConstructorReturn = _interopDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf = _interopDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var get = _interopDefault(require('lodash.get'));
var propTypes = require('./propTypes.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var tracked = (function (WrappedComponent) {
  var displayName = "Tracked(".concat(getDisplayName(WrappedComponent), ")");

  var TrackedComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(TrackedComponent, _React$Component);

    var _super = _createSuper(TrackedComponent);

    function TrackedComponent() {
      _classCallCheck(this, TrackedComponent);

      return _super.apply(this, arguments);
    }

    _createClass(TrackedComponent, [{
      key: "handleAnalytics",
      value: function handleAnalytics(handler, eventKey, e) {
        var tracker = this.context.tracker;
        var trackArgs = this.props.trackArgs;
        var sharedArgs = get(trackArgs, '_', {});
        var handlerArgs = get(trackArgs, handler, {});

        var args = _objectSpread(_objectSpread({}, sharedArgs), handlerArgs);

        if (tracker) {
          tracker.dispatch(eventKey, get(e, 'target.value', e), args);
        }

        if (this.props[handler]) {
          this.props[handler](e);
        }
      }
      /* eslint-disable react/jsx-no-bind */

    }, {
      key: "render",
      value: function render() {
        var _this = this;

        var track = this.props.track || {};
        var trackProps = {};
        Object.keys(track).forEach(function (k) {
          trackProps[k] = _this.handleAnalytics.bind(_this, k, track[k]);
        });

        var newProps = _objectSpread(_objectSpread({}, this.props), trackProps);

        return /*#__PURE__*/React__default.createElement(WrappedComponent, newProps);
      }
      /* eslint-enable react/jsx-no-bind */

    }]);

    return TrackedComponent;
  }(React__default.Component);

  _defineProperty(TrackedComponent, "contextTypes", {
    tracker: propTypes.default.Tracker
  });

  _defineProperty(TrackedComponent, "defaultProps", {
    track: undefined,
    trackArgs: undefined
  });

  process.env.NODE_ENV !== "production" ? TrackedComponent.propTypes = {
    track: PropTypes.objectOf(PropTypes.string),
    trackArgs: PropTypes.objectOf(PropTypes.object)
  } : void 0;
  TrackedComponent.displayName = displayName;
  TrackedComponent.WrappedComponent = WrappedComponent;
  return TrackedComponent;
});

exports.default = tracked;
